var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('span',{staticClass:"loader"},[_c('img',{staticClass:"spinner",attrs:{"src":"assets/ajax-spinner.gif"}})]):_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:({
            customClass: 'dismiss-all-notification-tooltip'
        }),expression:"{\n            customClass: 'dismiss-all-notification-tooltip'\n        }",modifiers:{"hover":true,"top":true}}],class:{
            'dismiss-all': true,
            notallowed: _vm.disabled
        },attrs:{"title":_vm.tooltip},on:{"click":_vm.handleClick}},[_c('span',[_vm._v(" "+_vm._s(_vm.dismissLabel)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }